import { TableCell, TableRow } from '@mui/material'
import { getDateForTable } from '@/utils'
import { RoundsReportLibraryColumnProps } from '@/state/reports/models'

export interface Props {
  row: RoundsReportLibraryColumnProps
}

const ReportsTableRowComponent = ({ row }: Props) => {
  return (
    <>
      <TableRow hover>
        <TableCell>{row.internalTransactionId}</TableCell>
        <TableCell>{row.playerId}</TableCell>
        <TableCell>{row.username}</TableCell>
        <TableCell>{row.gameProviderName}</TableCell>
        <TableCell>{row.gameCategoryName}</TableCell>
        <TableCell>{row.gameName}</TableCell>
        <TableCell>{row.transactionTypePayment}</TableCell>
        <TableCell>{row.debitTime && getDateForTable(row.debitTime)}</TableCell>
        <TableCell>
          {row.creditTime && getDateForTable(row.creditTime)}
        </TableCell>
        <TableCell>{row.bonusMoneyBetText}</TableCell>
        <TableCell>{row.bonusMoneyWinText}</TableCell>
        <TableCell>{row.balanceAfterText}</TableCell>
        <TableCell>{row.providerTransactionId}</TableCell>
        <TableCell>{row.providerRoundId}</TableCell>
      </TableRow>
    </>
  )
}

export default ReportsTableRowComponent
